import { render, staticRenderFns } from "./Personalize.vue?vue&type=template&id=7f03fece&scoped=true&"
import script from "./Personalize.vue?vue&type=script&lang=js&"
export * from "./Personalize.vue?vue&type=script&lang=js&"
import style0 from "./Personalize.vue?vue&type=style&index=0&id=7f03fece&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f03fece",
  null
  
)

export default component.exports